/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2024-01-26 09:26:46
 * @LastEditors: xiawenlong
 * @LastEditTime: 2024-01-26 09:31:22
 */
/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2022-11-14 10:11:32
 * @LastEditors: xiawenlong
 * @LastEditTime: 2024-01-26 09:30:57
 */
import Layout from '@/layout'
export default [
  {
    path: '/apply',
    name: 'Apply',
    component: Layout,
    redirect: '/apply/list',
    meta: { level: 1, title: '报考管理', icon: 'el-icon-monitor' },
    children: [
      {
        path: 'list',
        name: 'ApplyList',
        component: () => import(/*webpackChunkName:'ApplyList'*/ '@/views/apply/ApplyList/index'),
        meta: { title: '报考人员信息管理' },
      },
      {
        path: 'list/add',
        name: 'addMaterials',
        component: () => import(/*webpackChunkName:'ApplyList'*/ '@/views/apply/ApplyList/detail'),
        meta: { title: '编辑用户资料' },
      },
      {
        path: 'checkMaterials',
        name: 'checkMaterials',
        component: () => import(/*webpackChunkName:'ExamPlanAdd'*/ '@/views/apply/Materials/index'),
        meta: { title: '报名审核管理' },
      },
      {
        path: 'materialsDetail',
        name: 'materialsDetail',
        component: () =>
          import(/*webpackChunkName:'ExamPlanAdd'*/ '@/views/apply/Materials/detail'),
        meta: { title: '报名审核资料' },
      },
      {
        path: 'cardsManage',
        name: 'cardsManage',
        component: () =>
          import(/*webpackChunkName:'ExamPlanAdd'*/ '@/views/apply/CardsManage/index'),
        meta: { title: '准考证管理' },
      },
    ],
  },
]
